<template>
  <div class="login">
    <v-container>

      <v-row justify="center">
        <v-col cols="12" sm="4">
          <v-card class="pb-4">
            <v-row class="mt-2 pt-5">
              <v-col>
                <v-img src="@/assets/logo.png" alt="logo" contain height="150"></v-img>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <h3 class="headline grey--text text-center my-5">Logistics</h3>
                <h3 class="grey--text text-center my-5">Log Into your Account</h3>
              </v-col>
            </v-row>

            <v-row justify="center" class="my-4">
              <v-btn :href="loginO365" color="red">
                <v-icon class="white--text mr-4">mdi-office</v-icon>
                <span class="white--text">Login with Office365</span>
              </v-btn>
            </v-row>

          </v-card>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Login',

  data: () => ({
    loginO365: process.env.VUE_APP_API_URL + '/auth/azuread'
  })
}
</script>
